import { Toaster as ToasterHere } from "react-hot-toast";

export const Toaster = ToasterHere

